// extracted by mini-css-extract-plugin
export default {"root":"CourseHeader_root__iO6Ic","title":"CourseHeader_title__oWe7m","info":"CourseHeader_info__SZIea"};